<template>
  <div class="news-card-container">
    <v-card :to="to" flat>
      <picture>
        <img @error="onError" :src="parsedImg" :alt="title" width="100%" />
        <div class="date text-center">
          <div class="day">{{ parsedDate.dia }}</div>
          <div class="month">{{ parsedDate.mes }}</div>
        </div>
      </picture>

      <h3>{{ parsedTitle }}</h3>
    </v-card>
  </div>
</template>

<script>
import { formatToURL } from "../../utils/formatToURL";
import DefaultImg from "../../assets/img/default-img.png";

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    img: {
      type: String,
      default: DefaultImg,
    },
    title: {
      type: String,
      required: true,
    },
    date: {
      type: String,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: "/noticias",
    },
  },
  computed: {
    parsedTitle() {
      return this.title?.replace(/\\"/g, '"');
    },
    parsedImg() {
      let img = "";

      if (!/^https?:\/\//.test(this.img)) {
        img = this.files;
      }

      img += this.img;

      const width = this.type === "cover" ? 1000 : 400;

      return `${img}?resize=1&w=${width}`;
    },
    parsedDate() {
      if (this.date) {
        const data = new Date(this.date);
        return {
          mes: data.toLocaleString("pt-BR", { month: "short" }).slice(0, -1),
          dia: data.getDate(),
        };
      } else {
        return null;
      }
    },
    to() {
      const slug = formatToURL(this.title);

      return this.basePath + `/${slug}-${this.id}`;
    },
  },
  methods: {
    onError(e) {
      e.target.src = DefaultImg;
    },
  },
};
</script>

<style lang="scss">
.news-card-container {
  position: relative;

  picture {
    position: relative;

    img {
      border-radius: 20px;
      max-width: 100%;
    }

    .date {
      position: absolute;
      bottom: 20px;
      right: 20px;
      color: #fff;
      font-weight: 900;
      .day {
        font-size: 32px;
        line-height: 30px;
      }
    }
  }

  h3 {
    font-size: 18px;
    color: var(--v-text-base);
    margin-top: 10px;
  }
}
</style>
